class MFRHostedVideo {
  constructor(index, element) {
    this.$index = index;
    this.$element = $(element);

    this.selectors = {
      autoplayOnHoverState: ".autoplay-hover--enabled"
    }

    this.init();
  }

  init() {
    this.$video = this.$element.find("video");
    this.$cover = this.$element.find(".mfr-components__video-custom-poster");
    this.$playPauseButton = this.$element.find(".mfr-components__video-icon");
    this.$playPauseButtonV2 = this.$element.find(".play-pause-button");
    this.$speakerButton = this.$element.find(".speaker-button");

    this.$video.on("play", this.__handleVideoPlay.bind(this));
    this.$video.on("pause", this.__handleVideoPause.bind(this));

    this.$cover.on("click", this.__handleVideoClick.bind(this));
    this.$video.on("click", this.__handleVideoClick.bind(this)).on("volumechange", this.__handleVideoVolumeChange.bind(this));

    this.$playPauseButtonV2.on("click", this.__handleControlClick.bind(this));
    this.$speakerButton.on("click", this.__handleSpeakerButtonClick.bind(this));
  }

  __handleVideoPlay(e) {
    this.$playPauseButtonV2.removeClass("play pause").addClass("pause");
    this.$element.toggleClass("is-playing", !e.currentTarget.paused);
    this.$element.toggleClass("is-muted", e.currentTarget.muted);

    // Prevent playing multiple videos
    if (this.$element.parents(".carousel__slides").length > 0) {
      this.$element.parents(".carousel__item").siblings().each(function() {
        if ($(this).find("video").length > 0) {
          $(this).find("video").get(0).pause();
        }
      });
    }
  }

  __handleVideoPause(e) {
    this.$playPauseButtonV2.removeClass("play pause").addClass("play");
    this.$element.toggleClass("is-playing", !e.currentTarget.paused);
    this.$element.toggleClass("is-muted", e.currentTarget.muted);
  }

  __handleVideoClick(e) {
    if ($(e.currentTarget).attr("controls")) return;

    let videoElement = this.$video.get(0);

    if (videoElement.paused) videoElement.play();
    else videoElement.pause();
  }

  __handleControlClick(e) {
    let videoElement = this.$video.get(0);
    if (this.$playPauseButtonV2.hasClass("pause")) {
      videoElement.pause();
    } else {
      videoElement.play();
    }
  }

  __handleVideoVolumeChange(e) {
    this.$element.toggleClass("is-muted", e.currentTarget.muted);
  }

  __handleSpeakerButtonClick(e) {
    this.$video.get(0).muted = !this.$video.get(0).muted;
  }

  __handleAutoPlayOnHover(e) {
    const $parentContainer = $(this.selectors.autoplayOnHoverState);

    if ($parentContainer <= 0) return;

    let focusTimeout;

    $parentContainer.find(".mfr-components__video").each(function() {
      $(this).on("focusout mouseout", (e) => {
        focusTimeout = setTimeout(() => {
          $(this).find("video").get(0).pause();
        }, 100);
      });

      $(this).on("focusin mouseover", (e) => {
        clearTimeout(focusTimeout);
        $(this).find("video").get(0).play();
      });
    })
  }
}